import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "header", "footer", "children", "confirmButtonTitle", "cancelButtonTitle", "confirmButtonLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ExclamationCircleFilled, CheckCircleFilled, InfoCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Modal, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { styleVariables } from '../style';
import { getSize } from '../hooks';
import { PrimaryButton, SecondaryButton } from '../components/button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalType;

(function (ModalType) {
  ModalType["warning"] = "warning";
  ModalType["success"] = "success";
  ModalType["error"] = "error";
  ModalType["info"] = "info";
})(ModalType || (ModalType = {}));

var StyledModal = styled(Modal).withConfig({
  displayName: "modalcomponent__StyledModal",
  componentId: "sc-1gtiyom-0"
})([".ant-modal-content{border-radius:8px;}.ant-modal-header{border-radius:8px;border-bottom:none;}.ant-modal-footer{border-top:none;}.ant-modal-body{padding:", " ", " !important;font-size:16px;color:", ";line-height:1.5;}"], getSize('padding8'), getSize('padding24'), styleVariables.colors.gray11);
var ExclamationCircleFilledStyled = styled(ExclamationCircleFilled).withConfig({
  displayName: "modalcomponent__ExclamationCircleFilledStyled",
  componentId: "sc-1gtiyom-1"
})(["color:", ";"], styleVariables.colors.colorWarningBase);
var CheckCircleFilledStyled = styled(CheckCircleFilled).withConfig({
  displayName: "modalcomponent__CheckCircleFilledStyled",
  componentId: "sc-1gtiyom-2"
})(["color:", ";"], styleVariables.colors.colorSuccessBase);
var InfoCircleFilledStyled = styled(InfoCircleFilled).withConfig({
  displayName: "modalcomponent__InfoCircleFilledStyled",
  componentId: "sc-1gtiyom-3"
})(["color:", ";"], styleVariables.colors.colorInfoBase);
var CloseCircleFilledStyled = styled(CloseCircleFilled).withConfig({
  displayName: "modalcomponent__CloseCircleFilledStyled",
  componentId: "sc-1gtiyom-4"
})(["color:", ";"], styleVariables.colors.colorErrorBase);

var getIconComponent = function getIconComponent(type) {
  switch (type) {
    case ModalType.warning:
      return ExclamationCircleFilledStyled;

    case ModalType.success:
      return CheckCircleFilledStyled;

    case ModalType.error:
      return CloseCircleFilledStyled;

    case ModalType.info:
    default:
      return InfoCircleFilledStyled;
  }
};

export var ModalComponent = function ModalComponent(_ref) {
  var type = _ref.type,
      header = _ref.header,
      footer = _ref.footer,
      children = _ref.children,
      confirmButtonTitle = _ref.confirmButtonTitle,
      cancelButtonTitle = _ref.cancelButtonTitle,
      confirmButtonLoading = _ref.confirmButtonLoading,
      props = _objectWithoutProperties(_ref, _excluded);

  var IconComponent = getIconComponent(type);

  var modalHeader = header || /*#__PURE__*/_jsxs(Space, {
    size: 'middle',
    children: [type && /*#__PURE__*/_jsx(IconComponent, {}), /*#__PURE__*/_jsx("span", {
      children: props.title
    })]
  });

  var modalFooter = /*#__PURE__*/_jsxs(Space, {
    align: "end",
    children: [/*#__PURE__*/_jsx(SecondaryButton, {
      onClick: props.onCancel,
      children: cancelButtonTitle
    }), /*#__PURE__*/_jsx(PrimaryButton, {
      loading: confirmButtonLoading,
      onClick: props.onOk,
      children: confirmButtonTitle
    })]
  });

  return /*#__PURE__*/_jsx(StyledModal, _objectSpread(_objectSpread({}, props), {}, {
    title: modalHeader,
    footer: footer === null ? null : footer || modalFooter,
    children: children
  }));
};